import PropTypes from "prop-types";
import { FileIcon } from "lucide-react";

import {
  Attachment,
  AttachmentContent,
  AttachmentDescription,
  AttachmentMedia,
  AttachmentTitle,
  AttachmentTrigger,
} from "@/components/ui/attachment";
import { formatBytes } from "helpers/files";

export const describeFile = (type, size) =>
  [type, formatBytes(size)].filter(Boolean).join(" · ");

// A stored attachment in the `attachment_details_s3` shape, opened in a new
// tab. The xs size shows the title alone; the card is too narrow for more.
// A soft-deleted file (audit log entries keep them) is listed without a link.
function SavedAttachment({ attachment, size = "sm" }) {
  const isDeleted = !!attachment.deleted_at;

  return (
    <Attachment state="done" size={size}>
      {!isDeleted && (
        <AttachmentTrigger
          aria-label={attachment.file_name}
          render={
            <a
              href={attachment.url}
              target="_blank"
              rel="noopener noreferrer"
            />
          }
        />
      )}
      <AttachmentMedia>
        <FileIcon />
      </AttachmentMedia>
      <AttachmentContent>
        <AttachmentTitle
          className={
            isDeleted ? "tw:text-[var(--color-text-muted)]" : undefined
          }
        >
          {attachment.file_name}
        </AttachmentTitle>
        {isDeleted ? (
          <AttachmentDescription>Deleted</AttachmentDescription>
        ) : (
          size !== "xs" && (
            <AttachmentDescription>
              {describeFile(attachment.file_content_type, attachment.file_size)}
            </AttachmentDescription>
          )
        )}
      </AttachmentContent>
    </Attachment>
  );
}

SavedAttachment.propTypes = {
  attachment: PropTypes.shape({
    id: PropTypes.number,
    file_name: PropTypes.string.isRequired,
    file_size: PropTypes.number,
    file_content_type: PropTypes.string,
    url: PropTypes.string,
    deleted_at: PropTypes.string,
  }).isRequired,
  size: PropTypes.oneOf(["default", "sm", "xs"]),
};

export default SavedAttachment;
